window.onscroll = function() {
  scrollFunction();
};

function scrollFunction() {
  var toTopBtn = document.getElementById("toTopBtn");

  if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
    toTopBtn.style.display = "block";
  } else {
    toTopBtn.style.display = "none";
  }
}

function scrollToTop() {
  document.body.scrollTop = 0;  // Safari
  document.documentElement.scrollTop = 0;  // Chrome, Firefox, IE, Opera
}
